<script setup lang="ts">
import type { AgentPortfolioSectionSkeletonProps } from '.';

import { cn } from '~/utils';

import AgentCarouselSkeletonFooter from '~/components/Sections/AgentCarouselSkeletonFooter.vue';
import { Skeleton } from '~/components/ui/skeleton';

import {
	AGENT_PORTFOLIO_CARD_FOOTER_CLASS,
	AGENT_PORTFOLIO_ITEM_CLASS,
	AGENT_PORTFOLIO_SECTION_CLASS,
	AGENT_PORTFOLIO_VIEWPORT_CLASS
} from './layout';

defineProps<AgentPortfolioSectionSkeletonProps>();
</script>

<template>
	<section
		:class="cn(AGENT_PORTFOLIO_SECTION_CLASS, $props.class)"
		data-testid="agent-portfolio-section-skeleton"
		aria-busy="true"
		aria-label="Carregando portfólio de imóveis"
	>
		<div class="mb-6 flex h-9 items-center md:h-12" aria-hidden="true">
			<Skeleton
				is-active
				variant="white"
				class="h-[29px] w-[296px] max-w-full rounded-none motion-reduce:animate-none"
			/>
		</div>
		<div :class="AGENT_PORTFOLIO_VIEWPORT_CLASS" aria-hidden="true">
			<div class="flex gap-5">
				<div
					v-for="index in 2"
					:key="index"
					:class="
						cn(
							'min-w-0 shrink-0 grow-0 overflow-hidden border border-white-dark-3 md:border-0 md:ring-1 md:ring-inset md:ring-white-dark-3',
							AGENT_PORTFOLIO_ITEM_CLASS
						)
					"
					data-testid="agent-portfolio-card-skeleton"
				>
					<Skeleton
						is-active
						variant="white"
						class="h-[220px] w-full rounded-none motion-reduce:animate-none md:h-64"
					/>
					<div
						:class="
							cn('flex flex-col gap-2 p-4', AGENT_PORTFOLIO_CARD_FOOTER_CLASS)
						"
					>
						<div class="flex h-[30px] shrink-0 items-center">
							<Skeleton
								is-active
								variant="white"
								class="h-[18px] w-[115.477px] rounded-none motion-reduce:animate-none"
							/>
						</div>
						<div class="flex h-[18px] shrink-0 items-center gap-2">
							<template v-for="feature in 3" :key="feature">
								<Skeleton
									v-if="feature > 1"
									is-active
									variant="white"
									class="size-1 shrink-0 rounded-none motion-reduce:animate-none"
								/>
								<Skeleton
									is-active
									variant="white"
									class="h-4 w-[90px] min-w-0 rounded-none motion-reduce:animate-none"
								/>
							</template>
						</div>
						<div class="flex h-[18px] shrink-0 items-center">
							<Skeleton
								is-active
								variant="white"
								class="h-3.5 w-[258px] max-w-full rounded-none motion-reduce:animate-none"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
		<AgentCarouselSkeletonFooter full-width-button />
	</section>
</template>
